import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { useRegisterRequestStore } from '@/store/registerRequestStore';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';

interface RejectRequestDialogProps {
  requestId: string | null;
  requestName: string;
  onClose: () => void;
}

export function RejectRequestDialog({
  requestId,
  requestName,
  onClose,
}: RejectRequestDialogProps) {
  const { rejectRequest, isLoading } = useRegisterRequestStore();

  const handleReject = async () => {
    if (!requestId) return;
    
    try {
      await rejectRequest(requestId);
      onClose();
    } catch (error) {
      console.error('Failed to reject request:', error);
    }
  };

  return (
    <Dialog open={!!requestId} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>تأكيد رفض الطلب</DialogTitle>
        </DialogHeader>
        
        <div className="py-4">
          <div className="flex items-start gap-2 text-amber-600">
            <AlertTriangle className="h-5 w-5 mt-0.5" />
            <div className="space-y-2">
              <p className="text-sm font-medium">
                هل أنت متأكد من رفض طلب {requestName}؟
              </p>
              <p className="text-xs text-gray-500">
                لا يمكن التراجع عن هذا الإجراء.
              </p>
            </div>
          </div>
        </div>

        <DialogFooter className="gap-2">
          <Button
            variant="destructive"
            onClick={handleReject}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <LoadingSpinner className="ml-2" />
                جاري الرفض...
              </>
            ) : (
              'تأكيد الرفض'
            )}
          </Button>
          <Button
            variant="outline"
            onClick={onClose}
            disabled={isLoading}
          >
            إلغاء
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}